import {DocumentFragment} from '../types';
import {dmrbIndexer} from './dmrb-indexer';
import {FragmentIndexer} from './fragment-index.service';

export const mchwGeneralIndexer: FragmentIndexer = (document: DocumentFragment): Record<string, string> => {
  return dmrbIndexer(document);
};
